(function () {
  const FIXED_QTY_VARIANT_IDS = new Set([
    '46724530274462',
    '46724530307230',
    '46724530339998',
    '46724530372766',
  ]);

  function lockFixedCartQuantityInputs() {
    document.querySelectorAll('.quantity__input[data-quantity-variant-id]').forEach((input) => {
      const variantId = String(input.dataset.quantityVariantId);
      if (!FIXED_QTY_VARIANT_IDS.has(variantId)) return;

      // correct qty in cart if it's not already 1
      if (input.value !== '1') {
        input.value = '1';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      input.min = '1';
      input.max = '1';
      input.dataset.min = '1';
      input.readOnly = true;

      input.closest('quantity-input')?.querySelectorAll('button').forEach((button) => {
        button.disabled = true;
      });
    });
  }

  async function removeProductAndLinked(mainVariantId) {
    const cart = await fetch(`${routes.cart_url}.js`).then((response) => response.json());
    const updates = {};

    cart.items.forEach((item) => {
      if (Number(item.variant_id) === mainVariantId) {
        updates[item.key] = 0;
      }

      const parentVariantId =
        item.properties?._parent_variant_id || item.properties?.VariantId;

      if (parentVariantId && Number(parentVariantId) === mainVariantId) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) return;

    const response = await fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      console.error('Cart update failed:', error);
      return;
    }

    window.location.reload();
  }

  function handleRemoveClick(event) {
    const removeButton = event.target.closest('.cart-remove-button[data-variant-id]');
    if (!removeButton) return;

    const variantId = Number(removeButton.dataset.variantId);
    if (!FIXED_QTY_VARIANT_IDS.has(String(variantId))) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    removeProductAndLinked(variantId).catch((error) => {
      console.error(error);
    });
  }

  function init() {
    if (!document.querySelector('cart-items')) return;
    lockFixedCartQuantityInputs();
  }

  document.addEventListener('click', handleRemoveClick, true);
  document.addEventListener('DOMContentLoaded', init);
  init();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(init, 0));
  }
})();
